import { render } from "./InputConfirmation.vue?vue&type=template&id=0282cbd4"
import script from "./InputConfirmation.vue?vue&type=script&lang=js"
export * from "./InputConfirmation.vue?vue&type=script&lang=js"

import "./InputConfirmation.vue?vue&type=style&index=0&id=0282cbd4&lang=css"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__